import * as React from 'react';
import { IPurchaseContext, IPurchaseProviderProps } from '~/purchase/types';
// eslint-disable-next-line @wyz/module/no-relative-import
import { PurchaseContext } from './contexts';

export function PurchaseProvider({
  children,
  ...rest
}: React.PropsWithChildren<IPurchaseProviderProps>) {
  const context: IPurchaseContext = React.useMemo(
    () => ({
      mode: rest.mode,
      isCallCenterMode: rest.mode === 'CALL_CENTER',
    }),
    [rest],
  );
  return (
    <PurchaseContext.Provider value={context}>
      {children}
    </PurchaseContext.Provider>
  );
}

export const usePurchase = () => {
  const context = React.useContext(PurchaseContext);
  if (context === undefined) {
    throw new Error('usePurchase must be used within a PurchaseContext');
  }
  return context;
};
